module.exports = __webpack_public_path__ + "5457b171f880f0673888cadc16802d12.woff";